import {
  LISTA_VALIDACAO_PERFIL,
  LISTA_VALIDACAO_PERFIL_SUCESSO,
  LISTA_VALIDACAO_PERFIL_ERRO,
  APROVA_VALIDACAO_PERFIL,
  APROVA_VALIDACAO_PERFIL_SUCESSO,
  REPROVA_VALIDACAO_PERFIL,
  REPROVA_VALIDACAO_PERFIL_SUCESSO,
  VALIDACAO_PERFIL_ERRO,
} from 'constants/ActionTypes';

export const listaValidacaoPerfil = (pagina = 1, tamanhoPagina = 20, status = 'PENDENTE') => ({
  type: LISTA_VALIDACAO_PERFIL,
  payload: { pagina, tamanhoPagina, status },
});

export const listaValidacaoPerfilSucesso = (data) => ({
  type: LISTA_VALIDACAO_PERFIL_SUCESSO,
  payload: data,
});

export const listaValidacaoPerfilErro = (mensagem) => ({
  type: LISTA_VALIDACAO_PERFIL_ERRO,
  payload: mensagem,
});

export const aprovaValidacaoPerfil = (id, dataExpiracao) => ({
  type: APROVA_VALIDACAO_PERFIL,
  payload: { id, dataExpiracao },
});

export const aprovaValidacaoPerfilSucesso = () => ({
  type: APROVA_VALIDACAO_PERFIL_SUCESSO,
});

export const reprovaValidacaoPerfil = (id, motivo) => ({
  type: REPROVA_VALIDACAO_PERFIL,
  payload: { id, motivo },
});

export const reprovaValidacaoPerfilSucesso = () => ({
  type: REPROVA_VALIDACAO_PERFIL_SUCESSO,
});

export const validacaoPerfilErro = (mensagem) => ({
  type: VALIDACAO_PERFIL_ERRO,
  payload: mensagem,
});
